import classes from "./css/techArea.module.css"
import AboutText from "./aboutHelper/aboutText";
import SkillCarousel from "./aboutHelper/skillsCarusal";
import SocialLinks from "./aboutHelper/socialLinks";

const AboutArea=()=>{
    const aboutContent = "I am Vivek Sharma, a solution-driven developer who thrives on logic, structure, and innovation.With a deep love for technology, I focus on building systems that run smoothly, scale efficiently, and solve real-world problems with precision and care. My work lies where thoughtful engineering meets practical impact."
    return(
        <>
        <div className={classes.aboutArea}>
            <SkillCarousel/>
           <AboutText aboutText={aboutContent}/>
           <SocialLinks/>
           
        </div></>
    )
}


export default AboutArea;